module.exports = __webpack_public_path__ + "static/thales-6c6a271bc4ce8f3a7478c186258af7a8.png";